<template>
<div class="wenhui-tech-sitemap">
    <!-- 科技感Banner -->
    <div class="tech-sitemap-banner">
        <div class="banner-content">
            <h1>网站地图</h1>
            <p>快速导航至您需要的页面</p>
            <div class="tech-particles">
                <div class="particle" v-for="i in 20" :key="i" :style="{
                    left: `${Math.random()*100}%`,
                    top: `${Math.random()*100}%`,
                    animationDelay: `${Math.random()*2}s`
                }"></div>
            </div>
        </div>
    </div>

    <!-- 网站地图内容区域 -->
    <div class="section tech-sitemap-section">
        <div class="container">
            <el-row :gutter="30">
                <!-- 主导航部分 -->
                <el-col :xs="24" :sm="8" v-for="(group, index) in sitemapGroups" :key="index">
                    <el-card class="tech-sitemap-card" shadow="hover">
                        <div class="sitemap-group">
                            <h3 class="group-title">
                                <i :class="group.icon" class="group-icon"></i>
                                {{ group.title }}
                            </h3>
                            <ul class="sitemap-links">
                                <li v-for="(link, i) in group.links" :key="i">
                                    <router-link :to="link.path" class="sitemap-link">
                                        <i class="el-icon-arrow-right link-icon"></i>
                                        {{ link.name }}
                                        <el-tag v-if="link.new" type="danger" size="mini" effect="dark" class="new-tag">NEW</el-tag>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </el-card>
                </el-col>
            </el-row>

            <!-- 快速搜索区域 -->
            <div class="tech-search-section">
                <h3 class="search-title">找不到您需要的页面？</h3>
                <el-input placeholder="输入关键词搜索..." v-model="searchQuery" class="tech-search-input" @keyup.enter.native="handleSearch">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch">
                    </el-button>
                </el-input>
                <div class="search-tags">
                    <el-tag v-for="(tag, index) in popularTags" :key="index" type="info" effect="plain" @click="searchByTag(tag)">
                        {{ tag }}
                    </el-tag>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'WenhuiTechSitemap',
    data() {
        return {
            searchQuery: '',
            sitemapGroups: [{
                    title: '产品服务',
                    icon: 'el-icon-s-platform',
                    links: [{
                            name: '云计算服务',
                            path: '/products/cloud'
                        },
                        {
                            name: '大数据分析',
                            path: '/products/bigdata'
                        },
                        {
                            name: 'AI解决方案',
                            path: '/products/ai',
                            new: true
                        },
                        {
                            name: '物联网平台',
                            path: '/products/iot'
                        },
                        {
                            name: '企业定制开发',
                            path: '/products/custom'
                        }
                    ]
                },
                {
                    title: '技术支持',
                    icon: 'el-icon-s-tools',
                    links: [{
                            name: '技术文档',
                            path: '/support/docs'
                        },
                        {
                            name: 'API接口',
                            path: '/support/api'
                        },
                        {
                            name: '常见问题',
                            path: '/support/faq'
                        },
                        {
                            name: '视频教程',
                            path: '/support/tutorials'
                        },
                        {
                            name: '技术咨询',
                            path: '/support/contact'
                        }
                    ]
                },
                {
                    title: '关于我们',
                    icon: 'el-icon-s-data',
                    links: [{
                            name: '公司简介',
                            path: '/about'
                        },
                        {
                            name: '新闻动态',
                            path: '/news'
                        },
                        {
                            name: '加入我们',
                            path: '/careers'
                        },
                        {
                            name: '合作伙伴',
                            path: '/partners'
                        },
                        {
                            name: '联系我们',
                            path: '/contact'
                        }
                    ]
                }
            ],
            popularTags: ['API文档', '价格', '案例', '下载', '安全', '入门指南']
        }
    },
    methods: {
        handleSearch() {
            if (this.searchQuery.trim()) {
                this.$message.success(`正在搜索: ${this.searchQuery}`);
                // 实际项目中这里应该是调用搜索API
            }
        },
        searchByTag(tag) {
            this.searchQuery = tag;
            this.handleSearch();
        }
    }
}
</script>

<style lang="scss" scoped>
.wenhui-tech-sitemap {
    padding-top: 80px;
    background-color: #f5f7fa;

    .tech-sitemap-banner {
        height: 400px;
        background: linear-gradient(135deg, #0f2027, #203a43, #2c5364);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: #fff;
        position: relative;
        overflow: hidden;

        .banner-content {
            position: relative;
            z-index: 2;

            h1 {
                font-size: 60px;
                margin: 0 0 15px;
                font-weight: 700;
                text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
            }

            p {
                font-size: 24px;
                margin: 0;
                opacity: 0.9;
            }
        }

        .tech-particles {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;

            .particle {
                position: absolute;
                width: 3px;
                height: 3px;
                background: rgba(255, 255, 255, 0.7);
                border-radius: 50%;
                animation: float 5s infinite ease-in-out;
                opacity: 0.7;
            }
        }
    }

    .section {
        padding: 60px 0;

        &.tech-sitemap-section {
            background-color: #f5f7fa;
        }
    }

    .container {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
    }

    .tech-sitemap-card {
        margin-bottom: 30px;
        border-radius: 12px;
        transition: all 0.3s;
        border: none;

        &:hover {
            transform: translateY(-5px);
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
        }

        /deep/ .el-card__body {
            padding: 30px;
        }

        .sitemap-group {
            .group-title {
                color: #333;
                font-size: 22px;
                margin: 0 0 20px;
                padding-bottom: 15px;
                border-bottom: 1px solid #eee;
                display: flex;
                align-items: center;

                .group-icon {
                    color: #409EFF;
                    font-size: 24px;
                    margin-right: 10px;
                }
            }

            .sitemap-links {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    margin-bottom: 12px;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                .sitemap-link {
                    display: flex;
                    align-items: center;
                    color: #555;
                    text-decoration: none;
                    padding: 8px 0;
                    transition: all 0.3s;
                    font-size: 16px;

                    &:hover {
                        color: #409EFF;
                        transform: translateX(5px);

                        .link-icon {
                            opacity: 1;
                        }
                    }

                    .link-icon {
                        margin-right: 10px;
                        opacity: 0;
                        transition: all 0.3s;
                        color: #409EFF;
                    }

                    .new-tag {
                        margin-left: 8px;
                        transform: translateY(-2px);
                    }
                }
            }
        }
    }

    .tech-search-section {
        max-width: 800px;
        margin: 60px auto 0;
        text-align: center;
        background: #fff;
        padding: 40px;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

        .search-title {
            font-size: 24px;
            color: #333;
            margin: 0 0 30px;
        }

        .tech-search-input {
            /deep/ .el-input__inner {
                height: 50px;
                border-radius: 25px;
                padding: 0 25px;
                font-size: 16px;
                border: 1px solid #dcdfe6;
                transition: all 0.3s;

                &:focus {
                    border-color: #409EFF;
                    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
                }
            }

            /deep/ .el-input-group__append {
                border-radius: 0 25px 25px 0;
                background: #409EFF;
                border: none;

                .el-button {
                    color: #fff;
                    font-size: 18px;
                }
            }
        }

        .search-tags {
            margin-top: 25px;

            .el-tag {
                margin: 0 10px 10px 0;
                cursor: pointer;
                transition: all 0.3s;
                font-size: 14px;
                padding: 0 12px;
                height: 28px;
                line-height: 26px;

                &:hover {
                    background: #409EFF;
                    color: #fff;
                    transform: translateY(-2px);
                }
            }
        }
    }

    @media (max-width: 992px) {
        .tech-sitemap-banner {
            height: 350px;

            h1 {
                font-size: 48px;
            }

            p {
                font-size: 20px;
            }
        }

        .tech-search-section {
            padding: 30px;
        }
    }

    @media (max-width: 768px) {
        .tech-sitemap-banner {
            height: 300px;

            h1 {
                font-size: 36px;
            }

            p {
                font-size: 18px;
            }
        }

        .section {
            padding: 40px 0;
        }

        .tech-sitemap-card {
            margin-bottom: 20px;
        }
    }

    @media (max-width: 576px) {
        .tech-sitemap-banner {
            height: 250px;

            h1 {
                font-size: 28px;
            }

            p {
                font-size: 16px;
            }
        }

        .tech-search-section {
            padding: 20px 15px;

            .search-title {
                font-size: 20px;
                margin-bottom: 20px;
            }
        }
    }
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-20px);
    }
}
</style>
